// The assistant's refresh interval card (plan
// 2026-10-21-customer-source-cache-refresh-interval, step 9).
//
// On confirm the user's browser saves the interval through the same route the
// source drawer's "Dashboard cache" select uses, under the user's own JWT: the
// route decides (account owner or admin, direct-connect source, 1/4/8/24).
// The card states the value it saves, so a change made by someone else after
// the proposal is overwritten with what this person just confirmed.
import { updateDataSource, type CacheRefreshHours } from "@/api/dataSources";
import { registerAction } from "./registry";

registerAction("set_source_refresh_interval", async (params) => {
  const dataSourceId = params.data_source_id as string;
  const hours = params.cache_refresh_hours as CacheRefreshHours;
  await updateDataSource(dataSourceId, { cache_refresh_hours: hours });
  return {
    resultRef: { data_source_id: dataSourceId, cache_refresh_hours: hours },
    link: { label: "View source", to: "/data-management/sources" },
  };
});
